import { LOCATION_CHANGE } from "redux-first-history";

import { SortApplication } from "../../../actionTypes/applications";
import { GetHuntTalents } from "../../../actionTypes/hunt";

import { applicationStatuses } from "../../../interfaces/resources/application";
import { Talent } from "../../../interfaces/resources/talent";

export function contactedTalents(state: Talent[] = [], action: any) {
  switch (action.type) {
    case GetHuntTalents.SUCCESS:
      return action.contactedTalents;
    case SortApplication.SUCCESS:
      if (action.application.status === applicationStatuses.contacted) {
        const talent = action.application.talent;
        talent.applications = [action.application];
        return [talent, ...state];
      }
      return state;
    case LOCATION_CHANGE:
      return [];
    default:
      return state;
  }
}
